import React, { useState, useEffect } from 'react';
import styles from "./AppLoader.module.scss"
import { useSelector } from 'react-redux';
import { useRouter } from 'next/compat/router';
 
const AppLoader = () => {
  const [isLoading, setIsLoading] = useState(true);
  const router = useRouter();

  //  this code is checking if the page has finished loading after the component mounts.
  //  this code is used to fix the CLS issue for Home page
  useEffect(() => {
    function checkIfPageLoaded() {
      if (typeof document !== "undefined") {
         // Check if the document's readyState is "complete"
        if (document.readyState === "complete") {
          // Set isLoading to false if page is fully loaded
          setIsLoading(false);
        } else {
          setIsLoading(true);
          // Set a timeout to recheck if the page has loaded after 1 second
          setTimeout(checkIfPageLoaded, 1000);
        }
      }
    }
    checkIfPageLoaded();
  }, []);

  return (
    <>
      {/* check the loading state and homepage */}
      {isLoading && router.asPath==="/" && <div className={styles.loader_container}>
        <div className={styles.loader}></div>
      </div>}
    </>
  );
};

export default AppLoader;